function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.88 8.059H8.752v7.788H5.532V8.06H4V5.32h1.532V3.55c0-1.267.602-3.25 3.25-3.25l2.386.01v2.657H9.437c-.284 0-.684.142-.684.746v1.61h2.408l-.282 2.736z",
  fill: "url(#facebook_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "facebook_svg__paint0_linear",
  x1: 5.344,
  y1: 0.3,
  x2: 11.164,
  y2: 0.913,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgFacebook;